import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBTableHead,
  MDBTable,
  MDBTableBody,
  MDBContainer,
  MDBIcon,
  MDBSelect,
} from "mdbreact";
import _, { first } from "lodash";
import moment from "moment";
import { confirm as DevExtremeConfirm } from "devextreme/ui/dialog";
import BlockingModal from "./CalendarBlockingModal";
import { useState } from "react";
import {
  displayBreadcrumbs,
  showHideLoader,
  showNotification,
} from "../../../../actions";
import { useEffect } from "react";
import DatePicker from "react-datepicker";
import {
  getBlocksByLocationAndBlockDate,
  updateStatusBlock,
} from "../../../../apis/CalendarBlockingApi";
import { getLocations } from "../../../../apis/LocationApi";

function CalendarBlocking() {
  const initialState = {
    uuid: "",
    locationId: "",
    resourceIds: [],
    reason: "",
    timeFrom: "",
    timeTo: "",
    blockDate: "",
  };

  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const [blockPayload, setBlockPayload] = useState(initialState);
  const [blockDate, setBlockDate] = useState(new Date());
  const [blocks, setBlocks] = useState([]);
  const [reload, setReload] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [location, setLocation] = useState(null);

  useEffect(() => {
    dispatch(displayBreadcrumbs("Dashboard / Admin / Blocking"));
    getLocations().then((res) => {
      const locationRecords = res.data.data.records;
      const locationOptions = [];
      for (const locationRecord of locationRecords) {
        const option = {
          text: locationRecord.name,
          value: locationRecord,
          checked: false,
        };
        locationOptions.push(option);
      }
      const firstLocationOptions = locationOptions[0];
      if (firstLocationOptions) {
        firstLocationOptions.checked = true;
      }
      setLocationOptions(locationOptions);
    });
  }, []);

  useEffect(() => {
    if (!location) return;
    dispatch(showHideLoader(true));
    getBlocksByLocationAndBlockDate(
      location.id,
      moment(blockDate).format("YYYY-MM-DD"),
    ).then((res) => {
      dispatch(showHideLoader(false));
      setBlocks(res.data.data);
    });
  }, [showModal, reload, blockDate, location]);

  const handleBlockingModalClose = () => {
    setShowModal(false);
    setBlockPayload(initialState);
    setEdit(false);
  };
  const handleBlockingStatus = (uuid, name, status) => {
    status = parseInt(status);
    const action = status === 1 ? "release" : "enable";
    let result = DevExtremeConfirm(
      `Are you sure you want to ${action} <b>${name ? name : "Unknown"}</b>?`,
    );

    result.then(async (dialogResult) => {
      if (dialogResult) {
        dispatch(showHideLoader(true));

        try {
          let response = await updateStatusBlock(uuid, action);
          dispatch(showNotification("success", response.data.message));
        } catch (err) {
          dispatch(showNotification("error", err.data.message));
        } finally {
          dispatch(showHideLoader(false));
          setReload(!reload);
        }
      }
    });
  };

  const handleEditBlock = (block) => {
    setShowModal(true);
    setEdit(true);
    const resourceIds = [];
    if (block.resources) {
      const resources = Object.entries(block.resources);
      resources.map(([key, resource]) => resourceIds.push(resource.id));
    }
    setBlockPayload({
      name: block.name,
      uuid: block.uuid,
      locationId: location.id,
      resourceIds: resourceIds,
      reason: block.reason,
      timeFrom: block.local_time_from,
      timeTo: block.local_time_to,
      blockDate: new Date(block.block_date),
    });
  };

  return (
    <>
      <BlockingModal
        showModal={showModal}
        onClose={() => handleBlockingModalClose()}
        initialState={blockPayload}
        isEdit={edit}
        locationOptions={locationOptions}
      />
      <MDBContainer>
        <MDBRow>
          <MDBCol md="12">
            <MDBRow className="mb-4">
              <MDBCol md="6">
                <h3 className="mt-3">Calendar Blocking</h3>
              </MDBCol>
              <MDBCol md="6">
                <MDBBtn
                  color="primary"
                  onClick={() => setShowModal(true)}
                  className="float-right"
                >
                  Blocking
                </MDBBtn>
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="3">
                <label htmlFor="current_date" className="grey-text">
                  Current Date
                </label>
                <div style={{ marginTop: "1.5rem", marginBottom: "1.5rem" }}>
                  <DatePicker
                    id="current_date"
                    className="custom-input"
                    placeholderText="Click here"
                    clear
                    selected={blockDate}
                    onChange={(date) => {
                      if (!date) return;
                      setBlockDate(date);
                    }}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>
              </MDBCol>
              <MDBCol md="3">
                <label htmlFor="current_location" className="grey-text">
                  {" "}
                  Location
                </label>
                <MDBSelect
                  outline
                  id="current_location"
                  color="primary"
                  options={locationOptions}
                  getValue={(val) => {
                    if (!val || val.length < 0) return;

                    setLocation(val[0]);
                  }}
                />
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>

        <MDBTable
          responsive
          striped
          bordered
          hover={true}
          style={{ marginTop: "15px" }}
        >
          <MDBTableHead>
            <tr>
              <th className="text-center" width="15%">
                Block Name
              </th>
              <th className="text-center" width="15%">
                {" "}
                Resources
              </th>
              <th className="text-center" width="25%">
                Reason
              </th>
              <th className="text-center" width="15%">
                Duration
              </th>
              <th className="text-center" width="15%">
                Status
              </th>
              <th className="text-center" width="15%">
                Actions
              </th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {blocks &&
              blocks.map((block) => (
                <tr key={block.uuid}>
                  <td className="text-center">
                    {block.name ? block.name : "No Name"}
                  </td>
                  <td className="text-center">
                    <ul>
                      {block.resources &&
                        Object.entries(block.resources).map(
                          ([key, resource]) => (
                            <li key={key}>{resource.name}</li>
                          ),
                        )}
                    </ul>
                  </td>
                  <td className="text-center">
                    {block.reason && block.reason}
                  </td>
                  <td className="text-center">
                    {block.local_time_from + " - " + block.local_time_to}
                  </td>
                  <td className="text-center">
                    <span
                      className={`badge rounded-pill  ${
                        parseInt(block.is_active) !== 1
                          ? "danger-text"
                          : "success-text"
                      } `}
                    >
                      {parseInt(block.is_active) === 1 ? "Active" : "In Active"}
                    </span>
                  </td>
                  <td className="text-center">
                    <MDBIcon
                      style={{ cursor: "pointer" }}
                      icon="power-off"
                      className={`${
                        parseInt(block.is_active) !== 1
                          ? "danger-text"
                          : "success-text"
                      } mr-2`}
                      onClick={() =>
                        handleBlockingStatus(
                          block.uuid,
                          block.name,
                          block.is_active,
                        )
                      }
                    />
                    <MDBIcon
                      style={{ cursor: "pointer" }}
                      icon="edit"
                      className="cyan-text mr-2"
                      onClick={() => handleEditBlock(block)}
                    />
                  </td>
                </tr>
              ))}
          </MDBTableBody>
        </MDBTable>
      </MDBContainer>
    </>
  );
}
export default CalendarBlocking;
